import React from "react";
import { NavLink } from "react-router-dom";
import { Home, Wallet, Gift, FileText, User } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const items = [
  { to: "/customer", icon: Home, key: "home", testId: "nav-home" },
  { to: "/customer/wallet", icon: Wallet, key: "wallet", testId: "nav-wallet" },
  { to: "/customer/benefits", icon: Gift, key: "benefits", testId: "nav-benefits" },
  { to: "/customer/policy", icon: FileText, key: "policies", testId: "nav-policies" },
  { to: "/customer/profile", icon: User, key: "profile", testId: "nav-profile" },
];

export default function BottomNav() {
  const { t } = useI18n();
  return (
    <nav
      data-testid="customer-bottom-nav"
      className="fixed left-1/2 -translate-x-1/2 w-full max-w-[480px] z-[10000] bg-white/95 backdrop-blur-xl border-t border-slate-200 shadow-[0_-8px_24px_-12px_rgba(15,23,42,0.15)]"
      style={{ bottom: 0, paddingBottom: "max(env(safe-area-inset-bottom), 8px)" }}
    >
      <ul className="grid grid-cols-5">
        {items.map((it) => (
          <li key={it.to}>
            <NavLink
              to={it.to}
              end={it.to === "/customer"}
              data-testid={it.testId}
              className={({ isActive }) =>
                `flex flex-col items-center justify-center gap-1 py-3 tap-scale ${
                  isActive ? "text-tenant-primary" : "text-slate-400"
                }`
              }
            >
              {({ isActive }) => (
                <>
                  <it.icon className="w-5 h-5" strokeWidth={isActive ? 2.5 : 2} />
                  <span className={`text-[10px] font-semibold uppercase tracking-wider ${isActive ? "" : "opacity-70"}`}>
                    {t(it.key)}
                  </span>
                </>
              )}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
}
